/* eslint-disable array-element-newline */
/**
 * @typedef {Object} DateOffsetDict
 * @prop {number} years
 * @prop {number} months
 * @prop {number} days
 */

/**
 * @type {DateOffsetDict}
 */
export const DEFAULT_DATE_OFFSETS = {
	days: 0,
	months: 0,
	years: 0
};

/**
 * @param {Date} date
 * @param {DateOffsetDict} offsets
 */
export const calculateDateWithOffsets = (date, offsets = DEFAULT_DATE_OFFSETS) => {
	const mergedOffsets = {
		...DEFAULT_DATE_OFFSETS,
		...offsets
	};

	date.setFullYear(date.getFullYear() + mergedOffsets.years);
	date.setMonth(date.getMonth() + mergedOffsets.months);
	date.setDate(date.getDate() + mergedOffsets.days);

	return date;
};

/**
 * @param {Date | string} dateOrString
 * @param {DateOffsetDict} offsets
 */
export const formatDate = (dateOrString, offsets = DEFAULT_DATE_OFFSETS) => {
	const date = calculateDateWithOffsets(new Date(dateOrString), offsets);

	return `${String(date.getFullYear()).padStart(2, 0)}-${String(date.getMonth() + 1).padStart(2, 0)}-${String(date.getDate()).padStart(2, 0)}`;
};

/**
 * @example 'Saturday 25-11-2023'
 * @param {Date | string} dateOrString
 */
export const formatIntlDateDayOfWeek = (dateOrString) => {
	const date = new Date(dateOrString);
	const formatter = Intl.DateTimeFormat('en-AU', {
		day: '2-digit',
		month: '2-digit',
		weekday: 'long',
		year: 'numeric'
	});

	return formatter
		.format(date)
		.replace(/\//g, '-');
};

/**
 * @example 'Nov 24, 2023'
 * @param {Date | string} dateOrString
 */
export const formatIntlDate = (dateOrString) => {
	const date = new Date(dateOrString);
	const formatter = Intl.DateTimeFormat('en-US', {
		day: 'numeric',
		month: 'short',
		timeZone: 'Pacific/Auckland',
		year: 'numeric'
	});

	return formatter
		.format(date)
		.replace(/\//g, '-');
};

/**
 * @example 'Monday'
 * @param {Date | string} dateOrString
 */
export const formatIntlDayOfWeek = (dateOrString) => {
	const date = new Date(dateOrString);
	const formatter = Intl.DateTimeFormat('en-US', {
		timeZone: 'Pacific/Auckland',
		weekday: 'long'
	});

	return formatter
		.format(date);
};
